import React, { useState, useEffect } from 'react';
import creditCardType from "credit-card-type";
import { Button, Modal, ModalHeader, ModalBody, Row, Col } from 'reactstrap';
import './index.scss';
import { CardInput, TextInput } from "../../../components/common/FormsInput";
import { Formik, Form } from "formik";
import { addGaps, encrypt,addSlash } from './../../../utils/common'
import { PaymtInit, PaymtSchema } from "./schema"
const PaymentModal = ({ _handlePayment,_showModal ,_handleShowModal }) => {
    const [cardTypeImage, setCardTypeImage] = React.useState();
    const [payload, setPlayload] = useState(PaymtInit);


    useEffect(() => {
        setPlayload(PaymtInit)
        setCardTypeImage(cardImgs(''));
    }, []);

    const handleCardNumber = (fromk, e) => {
        const value = e.target.value;
        fromk.setFieldValue("card", value)
        let suggestion;

        if (value.length > 3) {
            suggestion = creditCardType(e.target.value)[0];
        }
        const cardType = suggestion ? suggestion.type : "unknown";
        setCardTypeImage(cardImgs(cardType));
    };

    const cardImgs = (cardType) => {
        let imageUrl;
        switch (cardType) {
            case "visa":
                imageUrl = require(`../../../assets/img/payment/card-logo-visa.svg`);
                break;
            case "mastercard":
                imageUrl = require(`../../../assets/img/payment/card-logo-mastercard.svg`);
                break;
            case "american-express":
                imageUrl = require(`../../../assets/img/payment/card-logo-amex.svg`);
                break;
            default:
                imageUrl = require(`../../../assets/img/payment/card-logo-unknown.svg`);
        }
        return imageUrl;
    }

    const _hendleForm = async (param, status) => {  
        let params = {};
        try {
            for (let [key, value] of Object.entries(param)) {
                params[key] = await encrypt(value);
            }
        } catch (err) {
        }
        _handlePayment(params)
    }
    return (
        <Modal isOpen={_showModal} toggle={_handleShowModal} className="payment-modal" size='md' backdrop="static">
            <ModalHeader>
                Payment Detail
                <Button color='link' onClick={_handleShowModal}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="34"
                        height="34"
                        viewBox="0 0 34 34"
                    >
                        <g data-name="Group 651" transform="translate(-1535 -134)">
                            <g
                                fill="#fff"
                                stroke="#000"
                                strokeWidth="2"
                                data-name="Ellipse 30"
                                opacity="0.3"
                                transform="translate(1535 134)"
                            >
                                <circle cx="17" cy="17" r="17" stroke="none"></circle>
                                <circle cx="17" cy="17" r="16" fill="none"></circle>
                            </g>
                            <path
                                d="M19.589 18l4.8-4.8a1.124 1.124 0 00-1.589-1.584l-4.8 4.8-4.8-4.8a1.124 1.124 0 10-1.584 1.584l4.8 4.8-4.8 4.8a1.124 1.124 0 001.584 1.584l4.8-4.8 4.8 4.8a1.124 1.124 0 101.584-1.584z"
                                data-name="Icon ionic-ios-close"
                                opacity="0.3"
                                transform="translate(1534.289 132.789)"
                            ></path>
                        </g>
                    </svg>
                </Button>
            </ModalHeader>
            <ModalBody>
                <div className='payment-info'>
                    <Formik
                        initialValues={payload}
                        enableReinitialize
                        validationSchema={PaymtSchema}
                        onSubmit={_hendleForm}
                    >
                        {(formik) => (<Form className='overflow-visible'>
                            <Row>
                                <Col xs="12">
                                    <CardInput
                                        name="card"
                                        placeholder="Card Number"
                                        value={addGaps(formik?.values?.card)}
                                        onChange={(v) => { handleCardNumber(formik, v) }}
                                        isRequired={true}
                                        cardtype={cardTypeImage}
                                        label="Card Number"
                                    />
                                    <div className='card-row d-flex'>
                                        <div className="col-cell holder">
                                            <TextInput
                                                name="holder"
                                                placeholder="Card Holder"
                                                value={formik?.values?.holder}
                                                onChange={formik.handleChange}
                                                isRequired={true}
                                                label="Card Holder"
                                            />
                                        </div>
                                        <div className="col-cell expiry">
                                            <TextInput
                                                name="exp"
                                                placeholder="MM/YY"
                                                maxLength="5"
                                                value={addSlash(formik?.values?.exp)}
                                                onChange={formik.handleChange}
                                                isRequired={true}
                                                label="Expiry"
                                            />
                                        </div>
                                        <div className="col-cell cvc">
                                            <TextInput
                                                name="cvv"
                                                maxLength="4"
                                                placeholder="cvv"
                                                value={formik?.values?.cvv}
                                                onChange={formik.handleChange}
                                                isRequired={true}
                                                label="CVV"
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className='foot'>
                                <Col xs="12" className='text-end'>
                                    <Button type="submit" color='primary'>Pay Now</Button>
                                </Col>
                            </Row>
                        </Form>)}
                    </Formik>
                </div>
            </ModalBody>
        </Modal>
    );
}

export default PaymentModal;